import { createHmac } from 'crypto';
import Flow from '../Flows/Flow';
import Reply from '../Actions/Reply';
export function getSha256Hash(secret, key) {
    const hmac = createHmac('sha256', secret);
    hmac.update(key);
    return hmac.digest('hex');
}
export function uniqueString() {
    return Math.random().toString(36).substring(2, 15)
        + Math.random().toString(36).substring(2, 15);
}
export function randomFlow() {
    return new Flow().addAction(uniqueString(), () => new Reply(uniqueString()));
}
export function compose(...fns) {
    return fns.reduce((a, b) => (...args) => b(a(...args)));
}
export function randInt() {
    return 1 + Math.round(1000 * Math.random());
}
/**
 * Create a static deep copy of a serealizable object
 */
export function deepCopy(obj) {
    const result = {};
    Object.keys(obj).map((key) => {
        const val = obj[key];
        if ((val !== null)
            && (!(val instanceof Date))
            && (typeof val === 'object')) {
            result[key] = deepCopy(val);
        }
        else {
            result[key] = val;
        }
    });
    return result;
}
